import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as SupplierCategoryAction from './../../../../actions/supplierCategoryAction';
import SupplierCategoryVW from './SupplierCategoryVW';
import { dragToOrderAction, getSupplierCategoryList, getVinwonderTagGroupListAll, updateDefaultTagInSupplier } from "./../../../../actions/vinwonderTagGroupAction";

const mapStateToProps = state => {
    return {
        vinwonderTagGroupState: state.vinwonderTagGroupReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getVinwonderTagGroupListAll: (filters) => dispatch(getVinwonderTagGroupListAll(filters)),
        getListSuppliers: (params) => dispatch(getSupplierCategoryList(params)),
        dragToOrderAction: (vinwonderTagGroup) => dispatch(dragToOrderAction(vinwonderTagGroup)),
        updateDefaultTagInSupplier: (vinwonderTagGroup) => dispatch(updateDefaultTagInSupplier(vinwonderTagGroup)),
        deleteSupplierCategoryAction: (category, refreshParams) => dispatch(SupplierCategoryAction.deleteSupplierCategoryAction(category, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SupplierCategoryVW));